import { z } from 'zod'
import { ROLES } from '../constants'
import { uuidSchema } from './common'

/** FR-AUTH — login shapes and the JWT claim set. */

export const emailLoginSchema = z.object({
  email: z.string().email().toLowerCase(),
  password: z.string().min(8).max(128),
})

export const pinLoginSchema = z.object({
  /** Device is registered first by a manager; the PIN only switches the operator. */
  deviceToken: z.string().min(10),
  pin: z.string().regex(/^\d{4,6}$/, 'PIN must be 4-6 digits'),
})

export const otpRequestSchema = z.object({
  email: z.string().email().toLowerCase(),
})

export const otpVerifySchema = z.object({
  email: z.string().email().toLowerCase(),
  code: z.string().regex(/^\d{6}$/),
})

export const switchBranchSchema = z.object({
  branchId: uuidSchema,
})

/** FR-AUTH-6 — the token carries every branch the user may act in. */
export const jwtClaimsSchema = z.object({
  sub: uuidSchema,
  role: z.enum(ROLES),
  branches: z.array(uuidSchema),
  activeBranch: uuidSchema.nullable(),
  name: z.string(),
  /** issued at / expiry, unix seconds */
  iat: z.number().int(),
  exp: z.number().int(),
  jti: z.string(),
})
export type JwtClaims = z.infer<typeof jwtClaimsSchema>

export const sessionUserSchema = z.object({
  id: uuidSchema,
  name: z.string(),
  email: z.string().nullable(),
  role: z.enum(ROLES),
  branches: z.array(z.object({ id: uuidSchema, code: z.string(), name: z.string() })),
  activeBranchId: uuidSchema.nullable(),
})
export type SessionUser = z.infer<typeof sessionUserSchema>

export const loginResultSchema = z.object({
  accessToken: z.string(),
  expiresIn: z.number().int(),
  user: sessionUserSchema,
})
